const FLOW_SERVER_PRODUCTION = 'https://link2do-flow-c4824eb67a53.herokuapp.com';
const FLOW_SERVER_LOCAL = 'http://localhost:5003';

const config = {
  serverUrl: FLOW_SERVER_LOCAL,
  clientUrl: 'http://localhost:3000',
  isProduction: false
};

// Detectar ambiente baseado na URL atual
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;

  // Produção
  if (hostname === 'link2.do' || hostname === 'www.link2.do' || hostname.includes('vercel')) {
    config.serverUrl = FLOW_SERVER_PRODUCTION;
    config.clientUrl = 'https://link2.do';
    config.isProduction = true;
  }
  // Desenvolvimento
  else {
    config.serverUrl = FLOW_SERVER_LOCAL;
    config.clientUrl = `${window.location.protocol}//${window.location.host}`;
    config.isProduction = false;
  }
}

// Override por variável de ambiente, para rodar o client local apontando para a
// API de produção: REACT_APP_FLOW_SERVER=... npm start
//
// Só vale fora de produção. No ar quem manda é a detecção por hostname, como
// sempre foi: se a variável do painel estiver desatualizada, o site continua
// falando com o servidor certo em vez de quebrar.
if (!config.isProduction) {
  if (process.env.REACT_APP_FLOW_SERVER) {
    config.serverUrl = process.env.REACT_APP_FLOW_SERVER;
  }
  if (process.env.REACT_APP_CLIENT_URL) {
    config.clientUrl = process.env.REACT_APP_CLIENT_URL;
  }
}

console.log('🌊 Flow Config:', {
  serverUrl: config.serverUrl,
  clientUrl: config.clientUrl,
  isProduction: config.isProduction
});

export default config;
